import React, { useRef } from "react";
import { useSecondaryToolbar } from "../../../Hooks/useSecondaryToolbar";
import { Container } from "@pixi/react";
import { useSelector } from "react-redux";
import {
  selectIntroPopupActive,
  selectSessionExpired,
  selectShowGameAfterTransition,
} from "../../../State/selectors";
import Settings from "./Settings/Settings";
import BuyBonusPopup from "./Popups/BuyBonusPopup";
import ToolbarTop from "./Toolbars/ToolbarTop";
import ToolbarBottom from "./Toolbars/ToolbarBottom";
import BetSelectPopup from "./Popups/BetSelectPopup";
import AutoplayPopup from "./Popups/AutoplayPopup";
import WarningPopup from "./Popups/WarningPopup";
import InfoPopup from "./Popups/InfoPopup";
import { FEATURES_CONFIG } from "../../../featuresConfig";
import DevPanel from "../shared/DevPanel/DevPanel";
// import ConnectionPopup from "../shared/Popups/ConnectionPopup";

const UserInterface = ({ children }) => {
  const toolbar = useSecondaryToolbar();
  const containerRef = useRef(null);
  const introPopupActive = useSelector(selectIntroPopupActive);
  const sessionExpired = useSelector(selectSessionExpired);
  const showGameAfterTransition = useSelector(selectShowGameAfterTransition);

  const getInterfaceAlpha = () => {
    if (showGameAfterTransition) {
      // Game interface should be fully visible after transition
      return 1;
    } else if (introPopupActive || sessionExpired) {
      // Game interface should be hidden when intro popup or reload dialog is active
      return 0.001;
    } else {
      // Default state - game interface visible
      return 1;
    }
  };

  const interfaceAlpha = getInterfaceAlpha();

  return (
    <>
      <Container
        ref={containerRef}
        name="secondary_user_interface"
        sortableChildren
        alpha={interfaceAlpha}
      >
        <ToolbarTop />
        {children}
        <ToolbarBottom />

        <Settings />
        <BetSelectPopup toolbar={toolbar} />
        <AutoplayPopup toolbar={toolbar} />

        {/* <ConnectionPopup /> */}
      </Container>

      {/* Render popups OUTSIDE the main container so they're always visible */}
      {FEATURES_CONFIG.BONUS_BUY.ENABLED && <BuyBonusPopup />}
      <WarningPopup />
      <InfoPopup />

      {/* Dev panel — test trigger buttons (top-left corner) */}
      {FEATURES_CONFIG.DEV_TOOLS.DEV_PANEL && <DevPanel />}
    </>
  );
};

export default UserInterface;
